import React, { Component } from "react";
import Images from "../Images";
import { AppConfig } from "../../../helpers";
import SlotGame from "./SlotGame";

class SlotsCourasel extends Component {
  constructor(props) {
    super(props);
    this.targetElementRef = React.createRef();
    this.targetImageRef = React.createRef();
    this.autoPlayInterval = null;
    this.autoPlayDebounceTimer = null;
    this.state = {
      elementWidth: 0,
      slideWidth: 0,
      currentSlideIndex: 0,
      largeSlide: this.props.largeSlideNumber || undefined,
      imageSpecialTypeId: this.props.imageSpecialTypeId,
      slides: this.props.slides || [],
      autoPlayEnabled: this.props.autoPlay,
      slidesToShow: this.props.slidesToShow || 1,
      autoPlayInterval: this.props.autoPlayInterval || 3000,
      autoPlayDebounce: this.props.autoPlayDebounce || 3000,
      isImagesCourasel: this.props.type == "images" ? true : false,
      multipleSlides: this.props.multipleSlides || false,
      scatter: this.props.scatter || false,
      largeSlideCondition:
        this.props.largeSlideNumber &&
        (this.props.imageSpecialTypeId == 1 || !this.props.imageSpecialTypeId),
    };
  }
  // slides: this.props.slides ? (this.props.type == "images" ? this.props.slides : this.props.slides.slice(6 , 12).concat(this.props.slides) ) : [],

  componentDidMount() {
    const { slides } = this.props;
    const { isImagesCourasel } = this.state;
    this.calculateElementWidth();
    // let currentIndex = 0
    // if(!isImagesCourasel){
    //   slides.map((slide,index)=>{
    //     if(slide.categoryId == window.location.pathname.split("/")[window.location.pathname.split("/").length - 1]){
    //       currentIndex=index
    //     }
    //   })
    //   this.setState({
    //     currentSlideIndex: currentIndex
    //   })
    // }
    window.addEventListener("resize", this.calculateElementWidth);
    if (this.state.autoPlayEnabled) this.startAutoPlay();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.calculateElementWidth);
    this.stopAutoPlay();
    this.clearAutoPlayDebounceTimer();
  }
  componentDidUpdate(prevProps, prevState) {
    // Start or stop auto-play based on autoPlayEnabled state change
    const { categoryId, isImagesCourasel, slides } = this.props;
    if (prevState.autoPlayEnabled !== this.state.autoPlayEnabled) {
      if (this.state.autoPlayEnabled) {
        this.startAutoPlay();
      } else {
        this.stopAutoPlay();
      }
    }
    // if(prevProps.categoryId !== categoryId ){
    //   let currentIndex = 0
    //   if(!isImagesCourasel){
    //     slides.map((slide,index)=>{
    //       if(slide.categoryId == window.location.pathname.split("/")[window.location.pathname.split("/").length - 1]){
    //         currentIndex=index
    //       }
    //     })
    //     this.setState({
    //       currentSlideIndex: currentIndex
    //     })
    //   }
    // }
  }
  calculateElementWidth = () => {
    const element = this.targetElementRef.current;
    const { largeSlideCondition } = this.state;
    if (element) {
      const boundingRect = element.getBoundingClientRect();
      let width;
      if (this.state.scatter) {
        // mock width
        width = boundingRect.width - 30;
      } else {
        //  real width
        width = boundingRect.width;
      }

      this.setState({
        elementWidth: width,
        slideHeight: width / this.state.slidesToShow,
        slideWidth: largeSlideCondition
          ? width / (this.state.slidesToShow + 1)
          : width / this.state.slidesToShow,
      });
    }
  };

  startAutoPlay = () => {
    this.autoPlayInterval = setInterval(
      this.goToNextSlide,
      this.state.autoPlayInterval
    );
  };

  stopAutoPlay = () => {
    clearInterval(this.autoPlayInterval);
  };

  toggleAutoPlay = () => {
    this.setState((prevState) => ({
      autoPlayEnabled: !prevState.autoPlayEnabled,
    }));
  };

  goToPreviousSlide = (makeDebounce = false) => {
    const { currentSlideIndex, autoPlayEnabled } = this.state;
    if (currentSlideIndex > 0) {
      this.setState({ currentSlideIndex: currentSlideIndex - 1 });
    }
    if (makeDebounce && autoPlayEnabled) this.handleSlideNavigation();
  };

  goToNextSlide = (makeDebounce = false) => {
    const { imageSpecialTypeId } = this.props;
    const { currentSlideIndex, slides, autoPlayEnabled } = this.state;
    if (
      this.state.isImagesCourasel &&
      currentSlideIndex <
        slides.length -
          this.state.slidesToShow -
          (imageSpecialTypeId == 3 || imageSpecialTypeId == 2 ? 1 : 0)
    ) {
      this.setState({ currentSlideIndex: currentSlideIndex + 1 });
    }
    if (!this.state.isImagesCourasel) {
      let newSlides = this.state.slides.concat(
        this.state.slides.slice(currentSlideIndex, currentSlideIndex + 1)
      );
      // this.setState({ currentSlideIndex: currentSlideIndex + 1 });
      this.setState({ slides: newSlides }, () => {
        // This callback will be executed after the state has been updated and the component has re-rendered
        this.setState({ currentSlideIndex: currentSlideIndex + 1 });
      });
    }
    if (makeDebounce && autoPlayEnabled) this.handleSlideNavigation();
  };
  clearAutoPlayDebounceTimer = () => {
    clearTimeout(this.autoPlayDebounceTimer);
  };
  handleSlideNavigation = () => {
    // Clear the auto-play debounce timer
    this.clearAutoPlayDebounceTimer();

    // Disable auto-play temporarily after arrow navigation
    this.setState({ autoPlayEnabled: false });

    // Start the auto-play debounce timer to re-enable auto-play
    this.autoPlayDebounceTimer = setTimeout(() => {
      this.setState({ autoPlayEnabled: true });
    }, this.state.autoPlayDebounce);
  };
  showGameGroup = (categoryId, currentSlideIndex) => {
    const { updateCategory } = this.props;
    updateCategory(categoryId, currentSlideIndex);
  };
  handleTouchpadScroll = (event) => {
    const deltaX = event.deltaX;
    const { startScroll } = this.state;
    if (this.time) clearTimeout(this.time);
    if (!startScroll) {
      if (deltaX > 0) {
        this.goToNextSlide(true);
        this.setState({ startScroll: true });
      } else if (deltaX < 0) {
        this.goToPreviousSlide();
        this.setState({ startScroll: true });
      }
    }
    this.time = setTimeout(() => {
      this.setState({
        startScroll: false,
      });
    }, 300);
  };

  render() {
    const {
      currentSlideIndex,
      slideWidth,
      slides,
      autoPlayEnabled,
      largeSlide,
      imageSpecialTypeId,
      largeSlideCondition,
    } = this.state;
    const { history, imageType } = this.props;

    // Calculate the transform value based on largeSlide condition
    const transformValue = -currentSlideIndex * slideWidth;

    return (
      <div
        ref={this.targetElementRef}
        className="custom-courasel-wrapper"
        style={
          !this.state.isImagesCourasel
            ? {
                position: "sticky",
                top: "119px",
                zIndex: "1",
                backgroundColor: "var(--black-to-gray)",
                paddingBottom: "10px",
              }
            : {}
        }
      >
        <div className="title-arrows-container">
          <h2
            className="title"
            onClick={() =>
              this.showGameGroup(this.props.categoryId, currentSlideIndex)
            }
          >
            {this.props.title}
          </h2>
          <div className="arrows-container">
            <button
              className="dark-btn"
              onClick={this.goToPreviousSlide}
              disabled={currentSlideIndex === 0}
            >
              <img src={Images.LT} alt="prev-arrow" />
            </button>
            <button
              className="dark-btn"
              onClick={() => this.goToNextSlide(true)}
              disabled={
                currentSlideIndex === slides.length - this.state.slidesToShow &&
                this.state.isImagesCourasel
              }
            >
              <img className="next-arrow" src={Images.LT} alt="next-arrow" />
            </button>
          </div>
        </div>
        <div className="custom-carousel" onWheel={this.handleTouchpadScroll}>
          <div
            className="carousel-inner"
            style={{
              display: "flex",
              transform: `translateX(${transformValue}px)`,
              transition: "transform 0.4s ease-in-out",
            }}
          >
            {slides.map((slide, index) =>
              (imageSpecialTypeId == 3 || imageSpecialTypeId == 2) &&
              index == slides.length - 1 ? null : (
                <div
                  key={index}
                  className="slide"
                  style={
                    slideWidth
                      ? {
                          width: `${
                            index === currentSlideIndex + (largeSlide - 1) &&
                            largeSlideCondition
                              ? slideWidth * 2
                              : slideWidth
                          }px`,
                        }
                      : {}
                  }
                >
                  {this.state.isImagesCourasel ? (
                    this.props.multipleSlides ? (
                      slide.map((innerSlide, index) => (
                        <SlotGame
                          style={
                            index !== 2
                              ? { marginBottom: "20px", maxHeight: "160px" }
                              : { maxHeight: "160px" }
                          }
                          src={
                            index === currentSlideIndex + (largeSlide - 1)
                              ? `${AppConfig.icons}${innerSlide.platformGameName}/${innerSlide.platformGameName}_h.webp`
                              : `${AppConfig.icons}${
                                  innerSlide.platformGameName
                                }/${
                                  innerSlide.slotsGameImages.filter(
                                    (game) => game.imageTypeId == imageType
                                  )[0]
                                    ? innerSlide.slotsGameImages.filter(
                                        (game) => game.imageTypeId == imageType
                                      )[0].gameImage
                                    : innerSlide.platformGameName
                                }.webp?id=${
                                  innerSlide.slotsGameImages.filter(
                                    (game) => game.imageTypeId == imageType
                                  )[0]
                                    ? innerSlide.slotsGameImages.filter(
                                        (game) => game.imageTypeId == imageType
                                      )[0].gameImageVersion
                                    : ``
                                }`
                          }
                          history={history}
                          gameId={innerSlide.gameId}
                        />
                      ))
                    ) : (
                      <>
                        {/*   imageSpecialTypeId == 1 is the normal cutomaizided large slider*/}
                        {imageSpecialTypeId == 1 || !imageSpecialTypeId ? (
                          <>
                            {/* horizantal image */}
                            {(index === currentSlideIndex + (largeSlide - 1) ||
                              index ===
                                currentSlideIndex + (largeSlide - 1) - 1 ||
                              index ===
                                currentSlideIndex + (largeSlide - 1) + 1) && (
                              <SlotGame
                                // className={this.state.largeSlideCondition && "large-slide-max-height"}
                                style={
                                  index === currentSlideIndex + (largeSlide - 1)
                                    ? {
                                        height: `${
                                          this.state.largeSlideCondition
                                            ? `${this.state.slideHeight}px`
                                            : "100%"
                                        }`,
                                        display: "block",
                                      }
                                    : { display: "none" }
                                }
                                src={`${AppConfig.icons}${
                                  slide.platformGameName
                                }/${slide.platformGameName}_h.webp?id=${
                                  slide.slotsGameImages.filter(
                                    (game) => game.imageTypeId == 4
                                  )[0]
                                    ? slide.slotsGameImages.filter(
                                        (game) => game.imageTypeId == 4
                                      )[0].gameImageVersion
                                    : ``
                                }`}
                                history={history}
                                gameId={slide.gameId}
                              />
                            )}
                            {/* regurlar image */}
                            <SlotGame
                              // className={this.state.largeSlideCondition && "large-slide-max-height"}
                              style={
                                index === currentSlideIndex + (largeSlide - 1)
                                  ? { display: "none" }
                                  : {
                                      display: "block",
                                      height: `${
                                        this.state.largeSlideCondition
                                          ? `${this.state.slideHeight}px`
                                          : "100%"
                                      }`,
                                    }
                              }
                              src={`${AppConfig.icons}${
                                slide.platformGameName
                              }/${
                                slide.slotsGameImages.filter(
                                  (game) => game.imageTypeId == imageType
                                )[0]
                                  ? slide.slotsGameImages.filter(
                                      (game) => game.imageTypeId == imageType
                                    )[0].gameImage
                                  : slide.platformGameName
                              }.webp?id=${
                                slide.slotsGameImages.filter(
                                  (game) => game.imageTypeId == imageType
                                )[0]
                                  ? slide.slotsGameImages.filter(
                                      (game) => game.imageTypeId == imageType
                                    )[0].gameImageVersion
                                  : ``
                              }`}
                              history={history}
                              gameId={slide.gameId}
                            />
                          </>
                        ) : null}
                        {/*   imageSpecialTypeId == 2 is the customized slider that displays two slides above each other*/}
                        {/* {(imageSpecialTypeId == 2 ) ? (
                      (index === currentSlideIndex + (largeSlide - 1)) ? (  
                      <div style={{display:"flex", flexDirection:"column" , gap:"10px" , justifyContent:"space-between"}}>
                        <SlotGame
                        src={
                          `${AppConfig.icons}${slide.platformGameName}/${slide.platformGameName}_s.webp`
                        }
                        history={history}
                        gameId={slide.gameId}
                      />
                        <SlotGame
                        src={
                          `${AppConfig.icons}${slides[index+1] && slides[index+1].platformGameName}/${slides[index+1] && slides[index+1].platformGameName}_s.webp`
                        }
                        history={history}
                        gameId={slides[index+1] ? slides[index+1].gameId : slide.gameId}
                      />
                      </div>): (index > currentSlideIndex + (largeSlide - 1)) ? ( <>
                        <SlotGame
                        style={{height:"100%"}}
                        src={
                          `${AppConfig.icons}${slides[index+1] && slides[index+1].platformGameName}/${slides[index+1] && slides[index+1].slotsGameImages.filter(game => game.imageTypeId ==imageType)[0] ? slides[index+1] && slides[index+1].slotsGameImages.filter(game => game.imageTypeId ==imageType)[0].gameImage : slides[index+1] && slides[index+1].platformGameName}.webp`
                        }
                        history={history}
                        gameId={slides[index+1] ? slides[index+1].gameId : slide.gameId}
                      />
                      
                          </>) :
                      ( 
                         <>
                            <SlotGame
                            style={{height:"100%"}}
                            src={
                              `${AppConfig.icons}${slide.platformGameName}/${slide.slotsGameImages.filter(game => game.imageTypeId ==imageType)[0] ? slide.slotsGameImages.filter(game => game.imageTypeId ==imageType)[0].gameImage : slide.platformGameName}.webp`
                            }
                            history={history}
                            gameId={slide.gameId}
                          />
    
                      </>
                      )
                    
                    ) :null} */}
                        {/* better UX */}
                        {imageSpecialTypeId == 2 ? (
                          <>
                            <div
                              style={
                                index === currentSlideIndex + (largeSlide - 1)
                                  ? {
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                      justifyContent: "space-between",
                                    }
                                  : { display: "none" }
                              }
                            >
                              <SlotGame
                                src={`${AppConfig.icons}${
                                  slide.platformGameName
                                }/${slide.platformGameName}_s.webp?id=${
                                  slide.slotsGameImages.filter(
                                    (game) => game.imageTypeId == 1
                                  )[0]
                                    ? slide.slotsGameImages.filter(
                                        (game) => game.imageTypeId == 1
                                      )[0].gameImageVersion
                                    : ``
                                }`}
                                history={history}
                                gameId={slide.gameId}
                              />
                              <SlotGame
                                src={`${AppConfig.icons}${slides[index + 1] &&
                                  slides[index + 1].platformGameName}/${slides[
                                  index + 1
                                ] &&
                                  slides[index + 1]
                                    .platformGameName}_s.webp?id=${
                                  slides[index + 1].slotsGameImages.filter(
                                    (game) => game.imageTypeId == 1
                                  )[0]
                                    ? slides[index + 1].slotsGameImages.filter(
                                        (game) => game.imageTypeId == 1
                                      )[0].gameImageVersion
                                    : ``
                                }`}
                                history={history}
                                gameId={
                                  slides[index + 1]
                                    ? slides[index + 1].gameId
                                    : slide.gameId
                                }
                              />
                            </div>

                            <SlotGame
                              style={
                                index > currentSlideIndex + (largeSlide - 1)
                                  ? { height: "100%" }
                                  : { display: "none" }
                              }
                              src={`${AppConfig.icons}${slides[index + 1] &&
                                slides[index + 1].platformGameName}/${
                                slides[index + 1] &&
                                slides[index + 1].slotsGameImages.filter(
                                  (game) => game.imageTypeId == imageType
                                )[0]
                                  ? slides[index + 1] &&
                                    slides[index + 1].slotsGameImages.filter(
                                      (game) => game.imageTypeId == imageType
                                    )[0].gameImage
                                  : slides[index + 1] &&
                                    slides[index + 1].platformGameName
                              }.webp?id=${
                                slides[index + 1].slotsGameImages.filter(
                                  (game) => game.imageTypeId == imageType
                                )[0]
                                  ? slides[index + 1].slotsGameImages.filter(
                                      (game) => game.imageTypeId == imageType
                                    )[0].gameImageVersion
                                  : ``
                              }`}
                              history={history}
                              gameId={
                                slides[index + 1]
                                  ? slides[index + 1].gameId
                                  : slide.gameId
                              }
                            />

                            <SlotGame
                              style={
                                index < currentSlideIndex + (largeSlide - 1)
                                  ? { height: "100%" }
                                  : { display: "none" }
                              }
                              src={`${AppConfig.icons}${
                                slide.platformGameName
                              }/${
                                slide.slotsGameImages.filter(
                                  (game) => game.imageTypeId == imageType
                                )[0]
                                  ? slide.slotsGameImages.filter(
                                      (game) => game.imageTypeId == imageType
                                    )[0].gameImage
                                  : slide.platformGameName
                              }.webp?id=${
                                slide.slotsGameImages.filter(
                                  (game) => game.imageTypeId == imageType
                                )[0]
                                  ? slide.slotsGameImages.filter(
                                      (game) => game.imageTypeId == imageType
                                    )[0].gameImageVersion
                                  : ``
                              }`}
                              history={history}
                              gameId={slide.gameId}
                            />
                          </>
                        ) : null}
                        {/* {(imageSpecialTypeId == 3 ) ? (
                      (index === currentSlideIndex + (largeSlide - 1)) ? (  
                      <div style={{display:"flex", flexDirection:"row" , justifyContent:"space-between"}}>
                        <SlotGame
                        style={{width:"47%"}}
                        src={
                          `${AppConfig.icons}${slide.platformGameName}/${slide.platformGameName}_s.webp`
                        }
                        history={history}
                        gameId={slide.gameId}
                      />
                        <SlotGame
                        style={{width:"47%"}}
                        src={
                          `${AppConfig.icons}${slides[index+1] && slides[index+1].platformGameName}/${slides[index+1] && slides[index+1].platformGameName}_s.webp`
                        }
                        history={history}
                        gameId={slides[index+1] ? slides[index+1].gameId : slide.gameId}
                      />
                      </div>): (index > currentSlideIndex + (largeSlide - 1)) ? ( <>
                        <SlotGame
                        style={{height:"100%"}}
                        src={
                          `${AppConfig.icons}${slides[index+1] && slides[index+1].platformGameName}/${slides[index+1] && slides[index+1].slotsGameImages.filter(game => game.imageTypeId ==imageType)[0] ? slides[index+1] && slides[index+1].slotsGameImages.filter(game => game.imageTypeId ==imageType)[0].gameImage : slides[index+1] && slides[index+1].platformGameName}.webp`
                        }
                        history={history}
                        gameId={slides[index+1] ? slides[index+1].gameId : slide.gameId}
                      />
                      
                          </>) :
                      ( 
                         <>
                            <SlotGame
                            style={{height:"100%"}}
                            src={
                              `${AppConfig.icons}${slide.platformGameName}/${slide.slotsGameImages.filter(game => game.imageTypeId ==imageType)[0] ? slide.slotsGameImages.filter(game => game.imageTypeId ==imageType)[0].gameImage : slide.platformGameName}.webp`
                            }
                            history={history}
                            gameId={slide.gameId}
                          />
    
                      </>
                      )
                    
                    ) :null} */}

                        {/* better UX */}
                        {imageSpecialTypeId == 3 ? (
                          <>
                            <div
                              style={
                                index === currentSlideIndex + (largeSlide - 1)
                                  ? {
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                    }
                                  : { display: "none" }
                              }
                            >
                              <SlotGame
                                style={{ width: "47%" }}
                                src={`${AppConfig.icons}${
                                  slide.platformGameName
                                }/${slide.platformGameName}_s.webp?id=${
                                  slide.slotsGameImages.filter(
                                    (game) => game.imageTypeId == 1
                                  )[0]
                                    ? slide.slotsGameImages.filter(
                                        (game) => game.imageTypeId == 1
                                      )[0].gameImageVersion
                                    : ``
                                }`}
                                history={history}
                                gameId={slide.gameId}
                              />
                              <SlotGame
                                style={{ width: "47%" }}
                                src={`${AppConfig.icons}${slides[index + 1] &&
                                  slides[index + 1].platformGameName}/${slides[
                                  index + 1
                                ] &&
                                  slides[index + 1]
                                    .platformGameName}_s.webp?id=${
                                  slides[index + 1].slotsGameImages.filter(
                                    (game) => game.imageTypeId == 1
                                  )[0]
                                    ? slides[index + 1].slotsGameImages.filter(
                                        (game) => game.imageTypeId == 1
                                      )[0].gameImageVersion
                                    : ``
                                }`}
                                history={history}
                                gameId={
                                  slides[index + 1]
                                    ? slides[index + 1].gameId
                                    : slide.gameId
                                }
                              />
                            </div>

                            <SlotGame
                              style={
                                index > currentSlideIndex + (largeSlide - 1)
                                  ? { height: "100%" }
                                  : { display: "none" }
                              }
                              src={`${AppConfig.icons}${slides[index + 1] &&
                                slides[index + 1].platformGameName}/${
                                slides[index + 1] &&
                                slides[index + 1].slotsGameImages.filter(
                                  (game) => game.imageTypeId == imageType
                                )[0]
                                  ? slides[index + 1] &&
                                    slides[index + 1].slotsGameImages.filter(
                                      (game) => game.imageTypeId == imageType
                                    )[0].gameImage
                                  : slides[index + 1] &&
                                    slides[index + 1].platformGameName
                              }.webp?id=${
                                slides[index + 1].slotsGameImages.filter(
                                  (game) => game.imageTypeId == imageType
                                )[0]
                                  ? slides[index + 1].slotsGameImages.filter(
                                      (game) => game.imageTypeId == imageType
                                    )[0].gameImageVersion
                                  : ``
                              }`}
                              history={history}
                              gameId={
                                slides[index + 1]
                                  ? slides[index + 1].gameId
                                  : slide.gameId
                              }
                            />

                            <SlotGame
                              style={
                                index < currentSlideIndex + (largeSlide - 1)
                                  ? { height: "100%" }
                                  : { display: "none" }
                              }
                              src={`${AppConfig.icons}${
                                slide.platformGameName
                              }/${
                                slide.slotsGameImages.filter(
                                  (game) => game.imageTypeId == imageType
                                )[0]
                                  ? slide.slotsGameImages.filter(
                                      (game) => game.imageTypeId == imageType
                                    )[0].gameImage
                                  : slide.platformGameName
                              }.webp?id=${
                                slide.slotsGameImages.filter(
                                  (game) => game.imageTypeId == imageType
                                )[0]
                                  ? slide.slotsGameImages.filter(
                                      (game) => game.imageTypeId == imageType
                                    )[0].gameImageVersion
                                  : ``
                              }`}
                              history={history}
                              gameId={slide.gameId}
                            />
                          </>
                        ) : null}
                      </>
                    )
                  ) : (
                    <div
                      onClick={() =>
                        this.showGameGroup(slide.categoryId, currentSlideIndex)
                      }
                      key={slide.categoryId}
                      style={{
                        background: `linear-gradient(83deg, ${slide.categoryTabColor} 0%, rgba(3, 79, 52, 0.00) 100%)`,
                      }}
                      // className={`slide-content`}
                      className={`slide-content ${this.props.categoryId ==
                        slide.categoryId && `selected-content`}`}
                    >
                      {slide.categoryId == 0 ? `All` : slide.categoryName}
                    </div>
                  )}
                </div>
              )
            )}
          </div>
        </div>

        {/* <div className="auto-play-toggle">
          <button onClick={this.toggleAutoPlay}>
            {autoPlayEnabled ? "Disable Auto Play" : "Enable Auto Play"}
          </button>
        </div> */}
      </div>
    );
  }
}

export default SlotsCourasel;
